/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Container } from 'react-bootstrap';

import { Col, Row } from 'react-bootstrap';
// import {
// } from 'react-icons/di';
import { SiGithub, SiInstagram, SiLinkedin } from 'react-icons/si';

function TechStack() {
  return (
    <Container fluid className="about-section">
      <Container>
        <h1 className="project-heading">
          <strong className="purple">Contact me for any query</strong>
        </h1>

        <Row style={{ justifyContent: 'center', paddingBottom: '300px' }}>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <a
              href="https://www.linkedin.com/in/prasanto19"
              style={{ color: 'white' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiLinkedin />
              Linkedin
            </a>
          </Col>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <a
              href="https://github.com/Prasanto19"
              style={{ color: 'white' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiGithub />
              Github
            </a>
          </Col>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <a
              href="https://www.instagram.com/prasanto19/"
              style={{ color: 'white' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiInstagram />
              Instagram
            </a>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default TechStack;
